import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowRight, Sparkles } from 'lucide-react';

/**
 * Dark mode gradient hero section
 * Features: Dark background with vibrant purple, blue, and green accents
 */
const GradientHero = ({ 
  title, 
  subtitle, 
  ctaPrimary, 
  ctaSecondary,
  onPrimaryClick,
  onSecondaryClick,
  showSparkle = true
}) => {
  return (
    <div className="relative overflow-hidden bg-gradient-to-br from-[#0f0f15] via-[#1a1a22] to-[#0f0f15] rounded-3xl p-12 mb-8 border border-purple-500/20 shadow-2xl">
      {/* Background Decorative Elements - Purple and Blue Glows */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-br from-purple-600/20 to-blue-500/20 rounded-full blur-3xl -z-10" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-gradient-to-tr from-cyan-400/20 to-purple-600/20 rounded-full blur-3xl -z-10" />
      
      <div className="relative z-10 max-w-4xl">
        {/* Optional Sparkle Badge */}
        {showSparkle && (
          <div className="inline-flex items-center gap-2 bg-purple-600/20 backdrop-blur-sm px-4 py-2 rounded-full border border-purple-500/40 mb-6 shadow-sm">
            <Sparkles className="w-4 h-4 text-[#4de1ff]" />
            <span className="text-sm font-medium text-[#4de1ff]">AI-Powered Platform</span>
          </div>
        )}
        
        {/* Hero Title - Gradient Text */}
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold bg-gradient-to-r from-white via-purple-200 to-cyan-200 bg-clip-text text-transparent mb-6 leading-tight">
          {title}
        </h1>
        
        {/* Subtitle */}
        <p className="text-lg sm:text-xl text-gray-300 mb-8 max-w-2xl leading-relaxed">
          {subtitle}
        </p>
        
        {/* CTA Buttons */}
        <div className="flex flex-wrap gap-4">
          {ctaPrimary && (
            <Button
              size="lg"
              onClick={onPrimaryClick}
              className="bg-gradient-to-r from-[#8d4dff] to-[#6a2ff0] hover:from-[#6a2ff0] hover:to-[#8d4dff] text-white shadow-lg shadow-purple-500/50 hover:shadow-xl hover:shadow-purple-500/70 transition-all duration-200 text-base px-8 border-0"
            >
              {ctaPrimary}
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          )}
          
          {ctaSecondary && (
            <Button
              size="lg"
              variant="outline"
              onClick={onSecondaryClick}
              className="border-2 border-[#4de1ff]/40 hover:border-[#4de1ff] hover:bg-[#4de1ff]/10 text-[#4de1ff] hover:text-white text-base px-8 transition-all duration-200 bg-transparent"
            >
              {ctaSecondary}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default GradientHero;
